import {
  isValidPhoneNumber,
  validatePhoneNumberLength,
} from "libphonenumber-js";

export const validatePasswordStrength = (password) => {
  // Minimum eight characters, at least one uppercase letter,
  // one lowercase letter and one number
  const regexp = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$");
  return regexp.test(password);
};

export const PASSWORD_STRENGTH_MESSAGE =
  "Requires min. 8 characters, 1 uppercase letter, 1 lowercase letter and 1 number";

export const validatePostalCode = (value, countryCode) => {
  let minPostalCodeLength = 0;
  let maxPostalCodeLength = 10;
  let msg = "";
  let allNumbers = true;
  switch (countryCode) {
    case "MY":
      minPostalCodeLength = 5;
      maxPostalCodeLength = 5;
      msg = "Postal code must be 5 digits";
      break;
    case "GB":
      value = value.replace(/\s+/g, "");
      value = value.replace(" ", "");

      minPostalCodeLength = 4;
      maxPostalCodeLength = 7;
      msg = "Postal code must be between 4 and 7 characters";
      break;
    case "AU":
      minPostalCodeLength = 4;
      maxPostalCodeLength = 4;
      msg = "Postal code must be 4 digits";
      break;
    case "FR":
      minPostalCodeLength = 5;
      maxPostalCodeLength = 5;
      msg = "Postal code must be 5 digits";
      break;
    case "SG":
      minPostalCodeLength = 6;
      maxPostalCodeLength = 6;
      msg = "Postal code must be 6 digits";
      allNumbers = !value.match(/[^0-9]/g);
      break;
    default:
      minPostalCodeLength = 4;
      maxPostalCodeLength = 10;
      msg = "Please enter a valid postal code";
  }
  if (
    !(
      value.length >= minPostalCodeLength && value.length <= maxPostalCodeLength
    )
  ) {
    return msg;
  }
  if (!allNumbers) {
    return "Postal code must be all numbers";
  }
  return "";
};

export const validateEmail = (value) => {
  if (value !== undefined) {
    return value.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
    );
  }
  return true;
};

/**
 *
 * @param {string} mobileNo
 * @param {string} callCode // e.g. SG/+65, US/+1
 * @returns {string}
 */
export const validateMobileNo = (mobileNo, callCode) => {
  const countryCode = callCode?.split("/")[0] || "";

  const lengthValidationResult = validatePhoneNumberLength(
    mobileNo,
    countryCode
  );

  if (lengthValidationResult === "TOO_LONG") {
    return "Mobile number is too long";
  } else if (lengthValidationResult === "TOO_SHORT") {
    return "Mobile number is too short";
  }

  if (!isValidPhoneNumber(mobileNo, countryCode)) {
    return "Invalid mobile number";
  }

  return "";
};

const isLetter = (char) => {
  const code = char.charCodeAt(0);
  return (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
};

/**
 *
 * @param {string} iossNumber
 * @returns {boolean}
 */
export const validateIossNumber = (iossNumber) => {
  if (typeof iossNumber !== "string" || iossNumber.length !== 12) {
    return false;
  }

  if (!isLetter(iossNumber[0]) || !isLetter(iossNumber[1])) {
    return false;
  }

  for (let i = 2; i < iossNumber.length; i++) {
    const charCode = iossNumber.charCodeAt(i);
    if (charCode < 48 || charCode > 57) {
      return false;
    }
  }

  return true;
};
